import React from "react"
import { get, find } from "lodash"
import { MenuPanel } from "components/organisms/panel"
import { Data } from "components/organisms/panel/data"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { DataCategory, ItemToCreateData } from "components/actions/ipo"
import { checkIsSp } from "utils/util"
import ClassNames from "classnames"
import { BaseSelect } from "components/atoms/input/select"

type PropsType = {
  currentContent: string
  changeContent: Function
  setRefresh: Function
  itemToCreateData: ItemToCreateData
}

export const DataTemplate: React.FC<PropsType> = props => {
  const { itemToCreateData } = props
  const isSp = checkIsSp()
  const menuTab = [
    {
      id: "ipo",
      name: "上場廃止・変更・追加",
      component: Data,
      componentProps: {
        itemToCreateData: itemToCreateData,
        label: DataCategory.ipo,
      },
    },
    {
      id: "split",
      name: "株式分割・併合・割当",
      component: Data,
      componentProps: {
        itemToCreateData: itemToCreateData,
        label: DataCategory.split,
      },
    },
    {
      id: "open",
      name: "公募・割当",
      component: Data,
      componentProps: {
        itemToCreateData: itemToCreateData,
        label: DataCategory.open,
      },
    },
    {
      id: "merge",
      name: "合併・株式交換",
      component: Data,
      componentProps: {
        itemToCreateData: itemToCreateData,
        label: DataCategory.merge,
        isUnitChangeTable: true,
      },
    },
    {
      id: "brandChangeLabel",
      name: "変更注意",
      component: Data,
      componentProps: {
        itemToCreateData: itemToCreateData,
        label: DataCategory.brandChangeLabel,
      },
    },
    {
      id: "Supervision",
      name: "監理・整理",
      component: Data,
      componentProps: {
        itemToCreateData: itemToCreateData,
        label: DataCategory.Supervision,
      },
    },
  ]
  return (
    <MainContainer className="domestic-container">
      <MenuPanel
        menu={menuTab}
        className={ClassNames("panel-symbol-info", { sp: isSp })}
        active={props.currentContent}
        refresh={() => props.setRefresh(true)}
        comboBox={isSp}
        addFilter={
          isSp && (
            <BaseSelect
              option={get(
                find(menuTab, { id: props.currentContent }),
                "componentProps.label"
              )}
              value={itemToCreateData.activeLabel}
              onChange={(id: number) => {
                if (id === itemToCreateData.activeLabel) return
                itemToCreateData.changeLabel(id)
                itemToCreateData.changePage(0)
                itemToCreateData.setData([])
                itemToCreateData.changeCategory(
                  get(
                    find(menuTab, { id: props.currentContent }),
                    `componentProps.label.${id}`
                  )
                )
              }}
            />
          )
        }
        changeMenu={(id: number | string) => {
          if (id === props.currentContent) return
          props.changeContent(id)
          itemToCreateData.setData([])
          itemToCreateData.changeCategory(get(DataCategory, `${id}[0]`))
          itemToCreateData.changeLabel(0)
          itemToCreateData.changePage(0)
        }}
      />
    </MainContainer>
  )
}
